import { render, staticRenderFns } from "./PrivacySection.vue?vue&type=template&id=452c01ea&scoped=true"
import script from "./PrivacySection.vue?vue&type=script&lang=js"
export * from "./PrivacySection.vue?vue&type=script&lang=js"
import style0 from "./PrivacySection.vue?vue&type=style&index=0&id=452c01ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c01ea",
  null
  
)

export default component.exports